import { createContext, useContext, useMemo, useState } from 'react';
import type { CardPlanToggleValue } from '@/components/Modals/SignUp/components/CardPlanToggle';
interface SidebarModalContextType {
  cardPlanToggleValue: CardPlanToggleValue;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  setCardPlanToggleValue: (newValue: CardPlanToggleValue) => void;
}
const SidebarModalContext = createContext<SidebarModalContextType>({
  open: false,
  onOpenChange: () => {},
  cardPlanToggleValue: 'creator',
  setCardPlanToggleValue: () => {}
});
export const useSidebarModalContext = () => {
  const context = useContext(SidebarModalContext);
  if (!context) {
    throw new Error('useSidebarModalContext must be used within an SidebarModalProvider');
  }
  return context;
};
interface SidebarModalProviderProps {
  children: React.ReactNode;
  value: SidebarModalContextType;
}
export const SidebarModalProvider = ({
  children,
  value
}: SidebarModalProviderProps) => {
  const [cardPlanToggleValue, setCardPlanToggleValue] = useState<CardPlanToggleValue>('creator');
  const providerValue = useMemo(() => ({
    ...value,
    cardPlanToggleValue,
    setCardPlanToggleValue
  }), [value, cardPlanToggleValue, setCardPlanToggleValue]);
  return <SidebarModalContext.Provider value={providerValue} data-sentry-element="SidebarModalContext.Provider" data-sentry-component="SidebarModalProvider" data-sentry-source-file="SidebarModalContext.tsx">
      {children}
    </SidebarModalContext.Provider>;
};